import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {TextField} from '@material-ui/core';
import {AbstractFormComponent, Icon} from 'front-onceforall-core';
import {requiredValidator} from 'front-onceforall-core/dist/utils/validators';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import projectService from '../../services/project/ProjectService';
import * as snackbarsActions from '../../actions/snackbars';
import ProjectInternalNote from './ProjectInternalNote';
import {captureError} from '../../utils/log';

const MAX_LENGTH = 1024;

export class ProjectInternalNotes extends AbstractFormComponent {
  getFormData() {
    return {
      contentNote: ''
    };
  }

  getFormValidators() {
    return {
      contentNote: requiredValidator
    };
  }

  handleSubmitCallback() {
    projectService.createInternalNote(this.props.projectId, this.state.formData)
      .then(() => {
        this.setState({submitting: false});
        this.props.onNewInternalNote();
      })
      .catch(error => {
        captureError('projectService.createInternalNote', error);
        this.props.actions.addError(<Translate value="error.generic"/>);
      });
  }

  render() {
    const notes = this.props.internalNotes.map((internalNote, index) => <ProjectInternalNote
      note={internalNote}
      key={index}
    />);
    const valueLength = this.state.formData.contentNote.length;
    return (
      <>
        {this.props.loading && <div className="loading-overlay"/>}
        <div className="col-12 inline-container space-between mb-4">
          <h2 className="m-0"><Translate value="project.internalNotes.title"/></h2>
          <button onClick={this.props.onClose}>
            <Icon
              icon="cross"
              size={20}
            />
          </button>
        </div>
        <form
          className="mt-4"
          onSubmit={this.handleSubmit}
        >
          <TextField
            autoFocus
            value={this.state.formData.contentNote}
            onChange={this.handleChange('contentNote')}
            helperText={this.helperText('contentNote')}
            error={this.isOnError('contentNote')}
            label={this.getFieldLabel('project.internalNotes.newInternalNote')}
            multiline
            rows={5}
            inputProps={{
              maxLength: MAX_LENGTH
            }}
          />
          <Translate
            value="message.textCounter"
            counter={this.state.formData.contentNote ? valueLength : 0}
            maxLength={MAX_LENGTH}
          />
          <div className="actions col-12 inline-container space-between">
            <button
              className="large primary inline-container"
              type="submit"
              disabled={this.state.submitting || this.props.loading}
            >
              <Icon icon={(this.state.submitting || this.props.loading) ? 'loader' : 'check'}/>
              <Translate value="action.confirm"/>
            </button>
          </div>
        </form>
        {notes.length > 0 && <hr className="my-5"/>}
        {notes}
      </>
    );
  }
}

ProjectInternalNotes.propTypes = {
  actions: PropTypes.object.isRequired,
  internalNotes: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onNewInternalNote: PropTypes.func.isRequired,
  projectId: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions}, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(ProjectInternalNotes);
